export default __webpack_public_path__ + "static/media/order_qty.69294b82.svg";